import { Cable, Search } from "lucide-react";

export function EmptyState({
  variant = "search",
  title,
  body,
}: {
  variant?: "search" | "source";
  title: string;
  body: string;
}) {
  const Icon = variant === "search" ? Search : Cable;

  return (
    <div className="empty-state">
      <Icon size={24} />
      <strong>{title}</strong>
      <span>{body}</span>
    </div>
  );
}
